export default __webpack_public_path__ + "static/media/src2_pitchnet.206b2840.mp3";